export const PANEL_NAMES = {
  keyword: 'keyword',
  location: 'location',
};

export const ITEM_TYPES = {
  location: 'location',
  venue: 'venue',
  activity: 'activity',
  bookmarks: 'bookmarks',
  links: 'links',
};

export const EVENTS = {
  clickKeywordBox: 'Search - Click Keyword Box',
  clickLocationBox: 'Search - Click Location Box',
  selectKeyword: 'Search - Select Keyword',
  selectLocation: 'Search - Select Location',
};

export const PANEL_ITEM_LIMIT = {
  activityMatches: 5,
  history: 3,
  venue: 6,
};

export const LOCATION_TYPES = {
  autocomplete: 'autocomplete',
  history: 'history',
};

export const SEARCHBOX_THEMES = {
  onDarkCentered: 'on-dark-centered',
};
